import * as d3 from 'd3'
import Chart from '../../ultils/Chart'
// import './styles.css'

class MarblesLegend extends Chart {
  init({ data, setMarblesData, activeNode }) {
    let vis = this
    vis.data = data
    vis.setMarblesData = setMarblesData
    vis.activeNode = data[0]

    vis.svg.attr('viewBox', '0 -50 350 600')

    vis.g
      .append('path')
      .attr('d', 'M230.363 486.725C104.794 361.156 104.794 157.569 230.363 32')
      .attr('stroke', '#E8EBEF')
      .attr('stroke-width', '3')
      .attr('stroke-linecap', 'round')
      .attr('fill', 'none')
  }

  mappingTitle(title) {
    let mappingTitle = ''
    switch (title) {
      case 'Elevated 3':
        mappingTitle = 'Elevated 3 Level of Risk'
        break
      case 'Elevated 2':
        mappingTitle = 'Elevated 2 Level of Risk'
        break
      case 'Elevated 1':
        mappingTitle = 'Elevated 1 Level of Risk'
        break
      case 'Neutral':
        mappingTitle = 'Neutral'
        break
      case 'Total':
        mappingTitle = 'Total'
        break
      default:
        mappingTitle = title
        break
    }
    return mappingTitle
  }

  update({ activeNode, data }) {
    let vis = this
    vis.data = data || vis.data
    vis.activeNode = activeNode || vis.data[0]

    vis.g.selectAll('.circleG').remove()
    vis.circles = vis.g.selectAll('.circleG').data(vis.data)

    vis.circlesG = vis.circles
      .enter()
      .append('g')
      .attr('class', 'circleG')
      .attr('transform', d => `translate(${d.cx}, ${d.cy})`)

    vis.circlesG.append('circle').attr('r', 14).attr('fill', 'white')

    vis.circlesG
      .append('circle')
      .attr('r', 7.5)
      .attr('fill', d => d.color)
      .attr('fill-opacity', 0.3)
      .attr('stroke', d => d.color)
      .attr('stroke-width', 3)
      .attr('cursor', 'pointer')
      .on('click', (_, d) => vis.setMarblesData(d))

    vis.circlesG
      .append('text')
      .attr('class', 'riskText')
      .attr('dy', 3)
      .attr('dx', d => -20)
      .attr('text-anchor', 'end')
      .attr('style', 'cursor: pointer')
      .text(d => vis.mappingTitle(d.title))
      .on('click', (_, d) => vis.setMarblesData(d))

    vis.companyCount = vis.circlesG
      .append('text')
      .attr('dx', 50)
      .attr('dy', 0)
      .attr('text-anchor', 'start')
      .attr('opacity', 0)
      .attr('class', 'legendChartCompanyCount')
      .text(d => d.count)

    vis.companyTitle = vis.circlesG
      .append('text')
      .attr('dx', 50)
      .attr('dy', 15)
      .attr('text-anchor', 'start')
      .attr('opacity', 0)
      .attr('class', 'legendChartCompany')
      .text('companies')

    vis.bobbles = vis.circlesG
      .append('image')
      .attr('class', 'bobble')
      .attr('xlink:href', d => d.bobbleImg)
      .attr('x', -30)
      .attr('y', -30)
      .attr('opacity', 0)
      .attr('pointer-events', 'none')

    vis.bobbles.attr('opacity', d => (d.name === vis.activeNode.name ? 1 : 0))

    vis.companyCount.attr('opacity', d =>
      d.name === vis.activeNode.name ? 1 : 0,
    )

    vis.companyTitle.attr('opacity', d =>
      d.name === vis.activeNode.name ? 1 : 0,
    )

    vis.circlesG
      .style('font-size', d =>
        d.name === vis.activeNode.name ? '18px' : '12px',
      )
      .style('line-height', d =>
        d.name === vis.activeNode.name ? '24px' : '18px',
      )
      .style('font-weight', d =>
        d.name === vis.activeNode.name ? '400' : '600',
      )

    vis.circlesG
      .selectAll('.riskText')
      .attr('dx', d => (d.name === vis.activeNode.name ? '-35' : '-15'))
  }
}

export default MarblesLegend
